import { createFilterAtoms } from '@/common/filtering/store.ts';
import { resetProjectPaginationOnFilterChangeAtom } from '@/features/data/projects/pagination.ts';
import {
  DEFAULT_PROJECT_FILTER,
  type ProjectFilterDefinition,
} from '@pac/filter/shared/projects';

export const projectFilterAtoms = createFilterAtoms<ProjectFilterDefinition>(
  DEFAULT_PROJECT_FILTER,
  resetProjectPaginationOnFilterChangeAtom,
);
